/*
 * A basic Modal component, originally made for PSP.
 */
import './styles/BasicModal.scss';
import CoreComponent from './CoreComponent';
import cloneGrandchildren from '../helpers/cloneGrandchildren';
import { Click } from './IconManager';

class Exit extends Click {
    constructor(props) {
        super(props);
        this.settings = {
            className: ['cf-icon-exit', 'exit', ...(props.classes || [])].join(' '),
            type: '',
        };
    }
}

class Modal extends CoreComponent {
    constructor(props) {
        super(props);
        this.OverlayRef = React.createRef();
        this.state = {
            isOpen: true,
        }
        this.validChildren = [
            CloseModal,
        ];
    }

    componentDidMount() {
        try {
            if (this.props.forceBlur) {
                if (this.OverlayRef.current) {
                    let active = (document.activeElement !== document.body ? document.activeElement : null);
                    if (active && !this.OverlayRef.current.contains(active)) {
                        active.blur();
                    }
                }
                this.setTimeout(() => this.componentDidMount(), 300);
            }
        } catch { /* Errored, otherwise pull focus from elements outside of the modal. */ }
    }

    close(onClose = () => { }) {
        this.setStatePrev({ isOpen: false }).then(() => {
            this.componentDidMount = () => { };
            onClose(!this.state.isOpen);
        })
    }

    render() {
        let { children, className, overlayClick, onClose, overlayStyle, style, ...props } = this.props;

        return (
            <div
                ref={this.OverlayRef}
                className={`flexboxgrid basic-modal modal-${this.state.isOpen ? 'open' : 'closed'}`}
                onClick={() => overlayClick || overlayClick === undefined ? this.close(onClose) : null}
                style={{ ...(overlayStyle || {}) }}
            >
                <span
                    className={`section ${className}`}
                    onClick={
                        (e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                        }
                    }
                    style={{ ...(style || {}) }}
                >
                    {
                        cloneGrandchildren(children, {
                            close: () => this.close(onClose),
                            parentState: { ...this.state },
                            ...props,
                        }, child => this.validChildren.some((type) => type === child.type))
                    }
                </span>
            </div>
        );
    }
}

class CloseModal extends CoreComponent {
    componentDidMount() {
        // Used to close the modal without rendering a close button.
        if (this.props.onMount) this.props.close();
    }

    render() {
        let { style, close, relative } = this.props;

        return (
            <Exit
                classes={relative ? ['relative'] : null}
                onClick={() => close()}
                style={{ ...(style || {}) }}
            />
        )
    }
}

export {
    Modal,
    CloseModal,
}
